'use client';

import { useQuery } from '@tanstack/react-query';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { isBot } from '@/utils/isBot';

interface HometownNewsDaysAgoProps {
  fallbackDate: string;
  id: number;
}

export const HometownNewsDaysAgo = ({
  fallbackDate,
  id,
}: HometownNewsDaysAgoProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const feedback = useQuery({
    ...(isLogin
      ? AuthQueryOptions[
          'get:/wello/v2/auth/hometown-news/feedback/{hometownNewsId}'
        ]
      : UnauthQueryOptions[
          'get:/wello/v2/allows/hometown-news/feedback/{hometownNewsId}'
        ])({
      path: {
        hometownNewsId: id!,
      },
    }),
    enabled: isLogin !== undefined && !!id && !isBot(),
    select: ({ context }) => ({
      daysAgo: context?.daysAgo,
    }),
  });

  const { daysAgo: clientDaysAgo } = feedback.data ?? {};
  const daysAgo = clientDaysAgo ?? fallbackDate;

  return <p className="text-Gray-700 typo-caption1">{daysAgo}</p>;
};
